// Tiny Web Audio synth for playing notes, chords, scales and progressions.
let ctx;
function getCtx() {
  if (!ctx) ctx = new (window.AudioContext || window.webkitAudioContext)();
  if (ctx.state === "suspended") ctx.resume();
  return ctx;
}
function midiToFreq(m) {
  return 440 * Math.pow(2, (m - 69) / 12);
}
function tone(freq, start, dur, gainVal = 0.18) {
  const c = getCtx();
  const o = c.createOscillator();
  const g = c.createGain();
  o.type = "triangle";
  o.frequency.value = freq;
  g.gain.setValueAtTime(0.0001, start);
  g.gain.linearRampToValueAtTime(gainVal, start + 0.01);
  g.gain.exponentialRampToValueAtTime(0.0001, start + dur);
  o.connect(g).connect(c.destination);
  o.start(start);
  o.stop(start + dur + 0.05);
}
export function playMidi(m, dur = 0.55) {
  const c = getCtx();
  tone(midiToFreq(m), c.currentTime, dur, 0.2);
}
export function playChord(midis, dur = 1.1) {
  const c = getCtx();
  midis.forEach((m) => tone(midiToFreq(m), c.currentTime, dur, 0.13));
}
export function playSequence(midis, step = 0.33) {
  const c = getCtx();
  let t = c.currentTime;
  midis.forEach((m) => {
    tone(midiToFreq(m), t, step * 0.95, 0.2);
    t += step;
  });
}
export function playProgression(chordMidiList, bpm, beatsPerChord, loop, onStep) {
  const secPerChord = (60 / bpm) * beatsPerChord;
  let stopped = false;
  let idx = 0;
  let timer = null;
  function step() {
    if (stopped) return;
    const i = idx % chordMidiList.length;
    playChord(chordMidiList[i], secPerChord * 0.95);
    if (onStep) onStep(i);
    idx++;
    if (!loop && idx >= chordMidiList.length) return;
    timer = setTimeout(step, secPerChord * 1000);
  }
  step();
  return () => {
    stopped = true;
    if (timer) clearTimeout(timer);
    if (onStep) onStep(-1);
  };
}
